/**
 * Report a bureau rejection (contracts/ui-api.md "Report a bureau rejection
 * (sheet 23)"; ANA.11, X.1, X.9; C-010). The wrapper derives the delivery
 * members itself (DM-01M39PR5FSZDGG214WPRBW9ZXD): a report naming a
 * transmission sends `delivered_myself: false` and its id; one without sends
 * `delivered_myself: true` and `transmission_id: null`, the hand delivery
 * mission 6 built (mission 7 WP07 T039; FR-017; research §1.16). The text is
 * never cached or logged.
 */
import { api, idSegment, oneOf } from '../api'
import { BUREAUS, type Bureau } from './headerParams'

/** The rejection text limit (mission 5 C-010). */
export const REJECTION_TEXT_MAX = 4000

export interface RejectionInput {
  bureau: Bureau
  /** YYYY-MM-DD, not after today in UTC. */
  rejected_on: string
  rejection_text: string
  contact_consent: boolean
  altered_after_download: boolean
  /** Mission 7: the `success` or `timeout` attempt this report is about; absent for a hand delivery. */
  transmission_id?: string
}

export interface RejectionReport {
  /** `RR-000123`, rendered in mono. */
  report_number: string
}

export async function reportRejection(id: string, input: RejectionInput): Promise<RejectionReport> {
  const path = `/runs/${idSegment(id, 'run id')}/rejection-report`
  const transmissionId = input.transmission_id
  if (transmissionId !== undefined) idSegment(transmissionId, 'transmission id')
  const body = {
    bureau: oneOf(input.bureau, BUREAUS, 'bureau'),
    rejected_on: input.rejected_on,
    rejection_text: input.rejection_text,
    delivered_myself: !transmissionId,
    transmission_id: transmissionId ?? null,
    contact_consent: input.contact_consent,
    altered_after_download: input.altered_after_download,
  }
  return api<RejectionReport>(path, { method: 'POST', body: JSON.stringify(body) })
}
